import React from "react";
import './quotebanner.css';

function QuoteBanner() {

    const sathyaSaiQuote = [
        { text: "Love lives by giving and forgiving. Ego lives by getting and forgetting." },
        { text: "The end of education is character." },
        { text: "Education should be for life, not for a living." },
        { text: "Money comes and goes. Morality comes and grows." },
        { text: "Work is worship. Duty is God." },
        { text: "Good company is important, it helps to cultivate good qualities" },
        { text: "Be simple and sincere." },
        { text: "The best way to find yourself is to lose yourself in the service of others." },
        { text: "Help ever, hurt never." },
        { text: "Love All, Serve All." },
        { text: "Surrendering the fruit of action to the Lord is real sacrifice." },
        { text: "The mind is a monkey, always restless, never still." },
        { text: "You must be the change you wish to see in the world." },
        { text: "A person is not great by birth, but by deeds." },
        { text: "Your duty is to be good, not to succeed. Let success take care of itself." },
        { text: "Love all, serve all. Help ever, hurt never." },
        { text: "The world is a drama, staged in a dream." },
        { text: "When you see God in all and all in God, then you will be free from all worries and fears." }
    ];
    // Pick a random quote
    const randomIndex = Math.floor(Math.random() * sathyaSaiQuote.length);
    const randomQuote = sathyaSaiQuote[randomIndex].text;

    return (
        <section id="cta-262">
            <div className="cs-container">
                {/* <div className="cs-left-section">
                    <h2 className="cs-title">Sri Sathya Sai Baba Says</h2>
                </div> */}
                <div className="cs-content">
                    <span className="cs-header">{randomQuote}</span>
                    {/* <p className="cs-p"> 
                        {randomQuote}
                    </p> */}
                </div>
                <picture className="cs-background">
                    <source media="(max-width: 600px)" srcSet="https://csimg.nyc3.digitaloceanspaces.com/CTA/cloth-m.jpg"></source>
                    <source media="(min-width: 601px)" srcSet="https://csimg.nyc3.digitaloceanspaces.com/CTA/cloth.jpg"></source>
                    <img aria-hidden="true" loading="lazy" decoding="async" src="https://csimg.nyc3.digitaloceanspaces.com/CTA/cloth.jpg" alt="Sathya Sai Quote" width="275" height="132"></img>
                </picture>
            </div>
        </section>
    );
}

export default QuoteBanner;